module.exports = __webpack_public_path__ + "static/jonathan-agoot-machine-learning-aws-near-serverless-architecure-d7cc6c6f6b7303a391ca659214f9a816.jpg";